export const highlight = (isHighlighted?: boolean) =>
  isHighlighted ? 'outline-accent-400 outline outline-dashed outline-2' : '';
